import React from 'react';
import {FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput} from "@mui/material";
import {ClearIcon, SearchIcon} from '../../../helpers/Icons'

function DataSearch(props) {
  const { searchText, setSearchText, clearSearch, handleSearchChange, handleSearchChangeKeyDown } = props;

  return (
      <FormControl
        variant="outlined"
        size="small"
        style={{width: '100%', backgroundColor: '#ffffff'}}
      >
        <InputLabel htmlFor="dataSearch">Search</InputLabel>
        <OutlinedInput
          id="dataSearch"
          type="text"
          label="Search"
          onChange={(e) => setSearchText(e.target.value)}
          value={searchText}
          onKeyDown={handleSearchChangeKeyDown}
          style={{height:'34px'}}
          endAdornment={
            <InputAdornment position="end" size="small">
              {!!searchText ?
              // todo: icon small
                <IconButton
                  id="searchClearButton"
                  aria-label="clear"
                  onClick={clearSearch}
                  edge="end"
                  size="small"
                >
                  <ClearIcon />
                </IconButton>
                : null}
                {/* todo: icon small */}
              <IconButton
                id="searchSubmitButton"
                aria-label="search"
                onClick={handleSearchChange}
                edge="end"
                size="small"
              >
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
  );
}

export default DataSearch;
